import { PAPER_TYPES } from "./constants";

// Get status badge color
export const getStatusColor = (status) => {
  switch (status) {
    case "active":
      return "bg-green-100 text-green-800";
    case "working":
      return "bg-yellow-100 text-yellow-800";
    case "closed":
      return "bg-gray-100 text-gray-800";
    default:
      return "bg-blue-100 text-blue-800";
  }
};

// Get paper type label
export const getPaperTypeLabel = (type) => {
  switch (type) {
    case PAPER_TYPES.SINGLE_DAY:
      return "Single Day";
    case PAPER_TYPES.WEEKLY:
      return "Weekly (7 days)";
    case PAPER_TYPES.HALF_MONTHLY:
      return "Half Monthly (15 days)";
    default:
      return type;
  }
};

// Generate unique 13-digit ID using timestamp and random values
export const generateUniqueId = () => {
  // Use crypto.getRandomValues for better randomness where available
  let randomPart;
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    const array = new Uint32Array(1);
    crypto.getRandomValues(array);
    randomPart = (array[0] % 1000).toString().padStart(3, "0");
  } else {
    randomPart = Math.floor(Math.random() * 1000).toString().padStart(3, "0");
  }
  const timestamp = Date.now().toString().slice(-10);
  return timestamp + randomPart;
};

// Convert file to base64
export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

// Convert base64 data URL to File object for upload
export const base64ToFile = (base64DataUrl, fileName) => {
  // Remove the data URL prefix to get just the base64 data
  const base64Data = base64DataUrl.split(',')[1];
  const binaryString = atob(base64Data);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  const blob = new Blob([bytes], { type: 'image/jpeg' });
  return new File([blob], fileName, { type: 'image/jpeg' });
};
